export default __webpack_public_path__ + "static/media/arena_11.3b5e2d61.jpeg";